import * as React from 'react';
import { IMedia } from '../../interfaces';
import config from '../../config';
import Favorite from '../parts/Favorite';
import { connect } from 'react-redux';
import { loadList } from '../../actions/playlist';
import { NavLink } from 'react-router-dom';
import { transliterate } from '../../utils/functions';

interface IProps {
    index?: number,
    track: IMedia,
    loadList?: any,
    hideArtist?: boolean,
    playlist: any,
    className?: string,
    style?: any
}

class Track extends React.Component<IProps, any>{
    playHandler (audio: IMedia){
        this.props.loadList([
            {
                name: audio.name,
                singer: audio.artist.full,
                // musicSrc: audio.fullpath,
                musicSrc: `${config.site}/site/upload/${audio.media_id}`,
                cover: "/images/music.png"
            }
        ]);
    }
    render() {
        let { track } = this.props;

        let [audio] = this.props.playlist.list;

        return (
            <li className={(audio && audio.name == track.name ? "rotate " : '') + this.props.className} style={this.props.style}>
                {this.props.index && <div className="numb">{this.props.index < 10 ? "0"+this.props.index : this.props.index}</div>}

                <div className="down_stat">
                    <a data-media="22323" href={`${config.site}/site/upload/${track.media_id}?type=download`} className="down">
                        <img src="/img/download.png" alt="" /> {track.download}
                    </a>
                </div>
                <div className="time_stat"> {track.time} </div>
                <div className="img_box">
                    <div className="icon_play">
                        <a href="#" onClick={(event: React.MouseEvent) => {
                            event.preventDefault();

                            this.playHandler(track);
                        }} className="player-play">
                            <i className="fa fa-play"></i>
                        </a>
                    </div>
                    <img src="/images/music.png" alt="" />
                </div>
                <div className="fav_stat">
                    <Favorite media={track}/>
                </div>
                <div className="name">
                    <b className="down" data-media="22323" data-tooltip="tooltip" data-placement="top"
                        title={track.name}> {track.name} </b>
                    {!this.props.hideArtist && track.artist && <NavLink to={"/singer/" + transliterate(track.artist.full) + "/" + track.artist.person_id} title={track.artist ? (track.artist.full) : ""}> {track.artist ? (track.artist.full) : ""} </NavLink>}
                </div>
            </li>
        );
    }
}

function mapStateToProps (state:any){
    return {
        playlist: state.playlist
    }
}

export default connect(mapStateToProps, {loadList})(Track);